var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91 1.7071 11.3244.293 16.0314 5l-4.7071 4.7071L9.9101 8.293l2.2901-2.29A7.1201 7.1201 0 0 0 12 6c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7c0-1.933-.7835-3.683-2.0503-4.9497L18.364 6.636C19.9926 8.2647 21 10.5147 21 13c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9c.0686 0 .137.0008.2053.0023L9.9101 1.707Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrowRight);
export default __webpack_public_path__ + "static/media/roundArrowRight.0831bbea18ec69de5fc8c4cd2f1a4dda.svg";
export { ForwardRef as ReactComponent };